import Swiper from 'swiper/bundle'; // css file is added locally

let fontSize = parseFloat($('body').css('font-size'));

$(window).on('resize', function () {
    fontSize = parseFloat($('body').css('font-size'));
});

const swiperCards = new Swiper('.testimonials__slider', {
    speed: 300,
    slidesPerView: 1.1,
    spaceBetween: fontSize,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: fontSize*2
        },
        1201: {
            slidesPerView: 3,
            spaceBetween: fontSize*2
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
});
